import { callGetApi } from '../apiCallerProxy';
import { pixelTesterApiFactory } from './pixelTesterApiFactory';

export * from './hooks';
export const { getPixelTester } = pixelTesterApiFactory({ callGetApi });
